import { connect } from 'react-redux';

import {
  applyFilters,
  clearHighlightedSKUsForProductsUsingCollectionIds,
  clearTextAssetsForProductsUsingCollectionIds,
  fetchCampaignLineCreatives,
  submit,
  toggleDelayReasonVisibility,
} from '../../campaign-editor/actions';
import campaignDatesChanged from '../../campaign-editor/utils/campaign-dates-changed';
import { removeCreativeAssociationFromProductsUsingCollectionIds } from '../../creative-assets/actions';
import { isPC } from '../../layout/Variant/Variant';
import ProjectCampaign from './ProjectCampaign';

const mapStateToProps = ({ campaignEditor }) => {
  if (!campaignEditor) {
    return {
      isDelayReasonVisible: false,
      campaign: {},
      campaignLinesById: {},
    };
  }
  const { campaign, campaignUI, campaignLinesById } = campaignEditor;
  return {
    isDelayReasonVisible: campaignUI && campaignUI.isDelayReasonVisible,
    campaign,
    campaignLinesById,
  };
};

const mapDispatchToProps = {
  applyFilters,
  clearHighlightedSKUsForProductsUsingCollectionIds,
  clearTextAssetsForProductsUsingCollectionIds,
  fetchCampaignLineCreatives,
  submit,
  toggleDelayReasonVisibility,
  removeCreativeAssociationFromProductsUsingCollectionIds,
};

const mergeProps = (
  { campaign, campaignLinesById, ...restStateProps },
  dispatchProps,
  ownProps,
) => ({
  ...restStateProps,
  onSubmit: async (event, initialCampaign) => {
    event.preventDefault();

    if (isPC()) {
      const datesChanged = campaignDatesChanged(
        initialCampaign.campaignLines,
        campaignLinesById,
      );

      // check if start date changes for future date
      if (campaign.pcDelayedStartReasons.length === 0 && datesChanged) {
        dispatchProps.toggleDelayReasonVisibility(true);
        return;
      }
    }

    await dispatchProps.removeCreativeAssociationFromProductsUsingCollectionIds();
    dispatchProps.clearHighlightedSKUsForProductsUsingCollectionIds();
    dispatchProps.clearTextAssetsForProductsUsingCollectionIds();
    await dispatchProps.submit(initialCampaign);
    await dispatchProps.applyFilters();
    // Update creative associations whenever a campaign line is edited
    await dispatchProps.fetchCampaignLineCreatives();
  },
  ...ownProps,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(ProjectCampaign);
